import { useState, useEffect } from 'react'
import api from '../services/api'

// Afastamentos de Funcionários (TAFASTA, frota.afasta) — "Atualizado" é gravado sozinho com a data do save

interface Afastamento { afacod: number; afades: string; afaesc: string; afadmo?: string; usos?: number }

const br = (iso?: string) => (iso ? iso.split('-').reverse().join('/') : '')

function Lista({ lista, onAdicionar, onEditar, onExcluir }: {
  lista: Afastamento[]
  onAdicionar: () => void
  onEditar: (a: Afastamento) => void
  onExcluir: (a: Afastamento) => void
}) {
  const [busca, setBusca] = useState('')
  const t = busca.trim().toUpperCase()
  const filtrada = t ? lista.filter(a => String(a.afacod).includes(t) || a.afades.toUpperCase().includes(t)) : lista
  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0 }}>Afastamentos cadastrados ({lista.length})</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div className="field" style={{ margin: 0 }}>
            <input value={busca} placeholder="Buscar código ou descrição" style={{ width: 240 }} onChange={e => setBusca(e.target.value)} />
          </div>
          <button className="btn btn-primary" onClick={onAdicionar}>+ Adicionar</button>
        </div>
      </div>

      {filtrada.length === 0 && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Nenhum afastamento encontrado.</p>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {filtrada.map(a => (
          <div key={a.afacod} style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{a.afacod} - {a.afades}</div>
              <div style={{ fontSize: '0.78rem', color: '#6b7280', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <span>Escala: <b>{a.afaesc === 'S' ? 'Sim' : 'Não'}</b></span>
                <span>Atualizado: <b>{br(a.afadmo) || '—'}</b></span>
                <span>Lançamentos: <b>{a.usos ?? 0}</b></span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
              <button className="btn btn-outline btn-sm" onClick={() => onEditar(a)}>Editar</button>
              <button className="btn btn-outline btn-sm" style={{ color: '#b91c1c' }} onClick={() => onExcluir(a)}
                disabled={(a.usos ?? 0) > 0} title={(a.usos ?? 0) > 0 ? 'Afastamento já lançado em funcionários' : undefined}>Excluir</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function Formulario({ editando, inicial, onVoltar, onSalvo }: {
  editando: boolean
  inicial: Afastamento
  onVoltar: () => void
  onSalvo: () => void
}) {
  const [form, setForm] = useState<Afastamento>(inicial)
  const [erro, setErro] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function salvar() {
    if (!form.afacod || form.afacod <= 0 || form.afacod > 999) { setErro('Código inválido (1 a 999).'); return }
    if (!form.afades.trim()) { setErro('Informe a descrição.'); return }
    setSalvando(true); setErro('')
    try {
      if (editando) await api.put(`/afastamentos/${form.afacod}`, form)
      else await api.post('/afastamentos', form)
      onSalvo()
    } catch (e: any) {
      setErro(e.response?.data?.error ?? 'Erro ao salvar.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0 }}>{editando ? 'Editar Afastamento' : 'Novo Afastamento'}</h3>
        <button className="btn btn-outline" onClick={onVoltar}>Voltar</button>
      </div>

      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div className="field">
          <label>Código *</label>
          <input type="number" min={1} max={999} value={form.afacod || ''} disabled={editando} style={{ width: '8ch' }}
            onChange={e => setForm(f => ({ ...f, afacod: Number(e.target.value) }))} />
        </div>
        <div className="field">
          <label>Descrição *</label>
          <input value={form.afades} maxLength={60} style={{ width: '62ch', maxWidth: '100%' }}
            onChange={e => setForm(f => ({ ...f, afades: e.target.value }))} />
        </div>
        <div className="field">
          <label>Escala?</label>
          <select value={form.afaesc} onChange={e => setForm(f => ({ ...f, afaesc: e.target.value }))}>
            <option value="N">Não</option>
            <option value="S">Sim</option>
          </select>
        </div>
        {editando && (
          <div className="field">
            <label>Atualizado</label>
            <input value={br(form.afadmo)} disabled style={{ width: '12ch' }} />
          </div>
        )}
      </div>

      {erro && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginTop: '0.75rem' }}>{erro}</div>}

      <div style={{ display: 'flex', gap: 8, marginTop: '1rem' }}>
        <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
          {salvando ? 'Salvando...' : editando ? 'Salvar alterações' : 'Adicionar'}
        </button>
        <button className="btn btn-outline" onClick={onVoltar}>Cancelar</button>
      </div>
    </div>
  )
}

export default function Afastamentos() {
  const [lista, setLista] = useState<Afastamento[]>([])
  const [carregado, setCarregado] = useState(false)
  const [atual, setAtual] = useState<Afastamento | null>(null)
  const [editando, setEditando] = useState(false)
  const [erro, setErro] = useState('')

  async function carregar() {
    const r = await api.get('/afastamentos')
    setLista(r.data)
    setCarregado(true)
  }

  useEffect(() => { carregar().catch(() => setErro('Erro ao carregar os afastamentos.')) }, [])

  async function excluir(a: Afastamento) {
    if (!window.confirm(`Excluir o afastamento "${a.afacod} - ${a.afades}"?`)) return
    setErro('')
    try {
      await api.delete(`/afastamentos/${a.afacod}`)
      await carregar()
    } catch (e: any) {
      setErro(e.response?.data?.error ?? 'Erro ao excluir.')
    }
  }

  return (
    <div style={{ maxWidth: 860 }}>
      <h2 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
        Afastamentos de Funcionários
        <span style={{ color: '#9ca3af', fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 400 }} title="Tabela frota.afasta">TAFASTA</span>
      </h2>
      {erro && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{erro}</div>}

      {!carregado ? null : atual ? (
        <Formulario key={atual.afacod || 'novo'} editando={editando} inicial={atual}
          onVoltar={() => setAtual(null)} onSalvo={async () => { await carregar(); setAtual(null) }} />
      ) : (
        <Lista lista={lista}
          onAdicionar={() => { setAtual({ afacod: 0, afades: '', afaesc: 'N' }); setEditando(false) }}
          onEditar={a => { setAtual({ ...a }); setEditando(true) }}
          onExcluir={excluir} />
      )}
    </div>
  )
}
